import './src/styles/globals.css'

export const onClientEntry = () => {
  document.documentElement.dataset.theme = 'workshop'
  document.documentElement.dataset.bg = 'parallax'
}

export const onRouteUpdate = () => {
  document.documentElement.dataset.theme = 'workshop'
  document.documentElement.dataset.bg = 'parallax'
}
